import { render, staticRenderFns } from "./ReminderCalendar.vue?vue&type=template&id=20eee0c4&scoped=true&"
import script from "./ReminderCalendar.vue?vue&type=script&lang=js&"
export * from "./ReminderCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20eee0c4",
  null
  
)

export default component.exports